
/*
 *
 * ┌────────────────────────────────────────────────────────────────┐
 * │                                                                │
 * │                       ____                __                   │
 * │                      / __ \___  ___  ____/ /                   │
 * │                     / /_/ / _ \/ _ \/ __  /                    │
 * │                    / _, _/  __/  __/ /_/ /                     │
 * │                   /_/ |_|\___/\___/\__,_/                      │
 * │                                                                │
 * │                                                                │
 * └────────────────────────────────────────────────────────────────┘
 *
 */




/*-----------------------------------------------------------------------------------*/
/*  00. COMPONENTS IMPORTS
/*-----------------------------------------------------------------------------------*/

import $ from 'domtastic'
import gsap from 'gsap'
import { CSSPlugin } from 'gsap/all'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { BiskitCookieConsent } from 'reed-biskit'

import Browser from '@comps/Browser'
import Router from '@comps/Router'
import Layout from '@comps/Layout'
import InertiaPlugin from '@js/vendors/gsap/InertiaPlugin.min'
import Draggable from '@js/vendors/gsap/Draggable.min'
import MotionPathPlugin from '@js/vendors/gsap/MotionPathPlugin.min'

gsap.registerPlugin(CSSPlugin, ScrollTrigger, Draggable, InertiaPlugin, MotionPathPlugin)
gsap.config({ nullTargetWarn: false })


const APP = window.APP || {}




/*-----------------------------------------------------------------------------------*/
/*  01. INIT
/*-----------------------------------------------------------------------------------*/

const initApp = () => {
    window.APP = APP

    APP.Browser = new Browser()
    APP.Router  = new Router()
    APP.Layout  = new Layout()

    if (document.querySelector('#biskit-cookie-panel')) {
        APP.CookieConsent = new BiskitCookieConsent({
            selector: '#biskit-cookie-panel',
            consentCallback: (consent) => {
                if (window.biskitSdk.consentFunction) {
                    window.biskitSdk.consentFunction(consent)
                }
                $(document).trigger('cookieConsentChanged')
            },
        })
    }
}

if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    initApp()
} else {
    document.addEventListener('DOMContentLoaded', initApp)
}



